import {store} from './store';

export default {
    template: `<div><slot v-bind="self"/></div>`,
    data() {
        return {
            store: store
        };
    },
    props: ["uid"],
    created() {
        this.store.mutations.setUid(this.uid);
    },
    computed: {
        getApiUrl(){
            return this.$config.API_URL + '/clustering';
        },
        self() {
            return this;
        },
    },
}
